/**
 * @file schemas/audit-report.ts
 * @description 稽核報告板塊相關的 Zod 輸入校驗 schema。
 * 供 API 路由層校驗 PUT 就地儲存端點的 request body。
 */
import { z } from 'zod';
import { reportBlockSchema } from '../audit-report/content-types';
/**
 * PUT /api/cases/:id/audit-report/versions/:vid — 草稿就地儲存
 * body: `{ blocks: ReportBlock[] }`
 * 至少需要一個板塊；每個板塊的結構須符合 reportBlockSchema。
 */
export const saveReportVersionSchema = z.object({
    blocks: z.array(reportBlockSchema).min(1),
});
